import { render, staticRenderFns } from "./RedeemDemographic.vue?vue&type=template&id=6663a170&"
import script from "./RedeemDemographic.vue?vue&type=script&lang=js&"
export * from "./RedeemDemographic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports